import "@hotwired/turbo-rails"
Turbo.session.drive = false
